class MainSlider extends HTMLElement {
  constructor() {
    super();
    this.loopSlider = document
      .querySelector("[data-hero-display]")
      .getAttribute("data-hero-display");
    this.initSlider();
  }

  initSlider() {
    const self = this;
    const swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      on: {
        init: function () {
          self.manageVideos(this);
        },
        slideChangeTransitionEnd: function (e) {
          let header = document.querySelector("#section-w-header .header");
          let activeSlide = e.wrapperEl.querySelector(".swiper-slide-active");
          let black_slide = activeSlide
            ? activeSlide.getAttribute("data-slide-black") == "true"
            : false;

          if (!header.classList.contains("header--scrolled")) {
            if (!black_slide) {
              header.classList.add("header--transparent");
              header.classList.remove("background-transparent");
            } else {
              header.classList.remove("header--transparent");
              header.classList.add("background-transparent");
            }
          }

          self.manageVideos(this);
        },
      },
    });
  }

  manageVideos(swiperInstance) {
    swiperInstance.el.querySelectorAll("video").forEach(function (v) {
      v.pause();
    });
    var activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (activeSlide) {
      activeSlide.querySelectorAll("video").forEach(function (v) {
        v.play().catch(function () {});
      });
    }
  }
}

customElements.define("main-slider", MainSlider);
